module.exports = __webpack_public_path__ + "img/ada.c1c9bce4.svg";